import { getCurrentTheme, switchTheme } from "../theme";
import { STORAGE, ThemeKey, ThemeKeyType, NewThemeMap } from "../constants";
import { Cookie } from "../utils";
import defaultTheme from "../theme/new/default-theme";

class ThemeManager {
  public theme;
  isMigu;
  isFox;
  isRenderBus;
  constructor() {}

  init() {
    this.setTheme();
    switchTheme(this.theme);
  }
  setJudge(theme?: ThemeKeyType) {
    this.isMigu = this.theme === ThemeKey.migu;
    this.isFox = [ThemeKey.foxrenderfarm, ThemeKey.renderbus_client].includes(
      this.theme
    );
    this.isRenderBus = [ThemeKey.renderbus, ThemeKey.renderbus_client].includes(
      this.theme
    );
  }

  setTheme(theme?: ThemeKeyType) {
    if (this.theme === ThemeKey.migu) {
      localStorage.setItem(STORAGE.CUSTOM, "");
    }
    this.theme = theme || getCurrentTheme();
    if (this.theme === ThemeKey.migu) {
      localStorage.setItem(
        STORAGE.CUSTOM,
        `${this.theme}|${Cookie.getCookie(STORAGE.RAYVISION_USERKEY)}`
      );
    }
    this.setJudge(this.theme);
  }

  get newTheme() {
    return NewThemeMap.get(this.theme) ?? defaultTheme;
  }
}

export default new ThemeManager();
